import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--prevent-enter"
export default class extends Controller {
  connect() {
    this._onKeydown = this._onKeydown.bind(this);
    this.element.addEventListener("keydown", this._onKeydown);
  }

  disconnect() {
    this.element.removeEventListener("keydown", this._onKeydown);
  }

  _onKeydown(e) {
    const tagName = e.target.tagName.toLowerCase();
    if (tagName !== "input" && tagName !== "select") {
      return;
    }

    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }
}
